import type { ApplicationContext } from '@hc-frontend/core-context';
import { createErrorOperationResult } from '@hc-frontend/core-utils-business-operation';

import type { UserAdsOptions } from '../../entities';
import { DefaultUserAdsOptions } from '../../entities';
import type {
  FeatureAdsResult,
  FeaturedAdsRepository,
} from '../../repositories';

export type GetFeatureAdsUseCase = (
  options: UserAdsOptions,
) => Promise<FeatureAdsResult>;

export const getFeaturedAdsFactory =
  ({
    getFeaturedAds,
    log,
  }: Pick<FeaturedAdsRepository, 'getFeaturedAds'> &
    Pick<ApplicationContext, 'log'>): GetFeatureAdsUseCase =>
  async (options) => {
    const parsedOptions = DefaultUserAdsOptions.safeParse(options); // Create default user profile

    if (!parsedOptions.success) {
      log({
        type: 'error',
        context: 'server',
        message: 'failedToFetchFeaturedAds',
        data: {
          rootCause: parsedOptions.error,
        },
      });
      return createErrorOperationResult({
        errors: [
          {
            code: 'failedToFetchFeaturedAds',
            rootCause: parsedOptions.error,
          },
        ],
      });
    }

    const result = await getFeaturedAds(parsedOptions.data);

    if (!result.success)
      log({
        type: 'error',
        context: 'server',
        message: result.errors[0].code,
        data: {
          rootCause: result.errors[0].rootCause,
        },
      });

    return result;
  };
